// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unread_count {\n  position: absolute;\n  top: 39%;\n  right: 15px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: red;\n  color: #fff;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n}\n.quota {\n  float: right;\n  margin-right: 6px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
